import axios from "../../../../services/axiosInstance";

export function transferAmount(data) {
  return axios.post("transfer-amount", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function getTransactions(queryParams) {
  return axios.get("transactions", { params: queryParams });
}

export function getAmountInfo() {
  return axios.get("amount-info");
}

export function disconnectStripeAccount(disconnectType){
  return axios.post('stripe-account-disconnect', { disconnect_type: disconnectType });
}

export function getStripeAccountSetup() {
  return axios.get("stripe-account-setup");
}

export function getStripeAccountInfo() {
  return axios.get("stripe-account-info");
}

export function getStripeAccountLogin() {
  return axios.get("stripe-account-login");
}

export function fetchAmountStatsGraphData(filter) {
  return axios.get("graph-data", { params: { filter } });
}

export function fetchTrophiesRoomList(queryParams) {
  return axios.get("trophy-room", { params: queryParams });
}

export function getDocument(queryParams) {
  return axios.get("documents", { params: queryParams });
}

export function searchUserStand(text) {
  return axios.get(`/user-payments-stands?title=${text}`);
}

export function fetchMaintenanceBanner() {
  return axios.get(`/maintenance-banner`);
}